<template>
  <div class="ce-info">
    <additional-fixed-tabs
      v-if="!isSingleSession"
      :tabs="CEInfoTabs"
      :show-filter-button="false"
      additionalFixedTabsClass="additional-fixed-tabs-ce-info"
    />

    <div v-if="isFetching" class="page-loader">
      <c-loader />
    </div>

    <!--       ERROR -->
    <div v-else-if="!isFetching && errorStatus">
      <ErrorPage :status="errorStatus"/>
    </div>

    <div v-else :style="`${isSingleSession ? 'margin-top: 20px;' : ''}`">

      <div v-if="data.qa_code" class="qr-code-wrapper">
        <h4>This is your ID Code to scan in and out of sessions for attendance tracking purposes.</h4>
        <img width="150" :src="`${data.qa_code}`" alt="qr code" class="info__qr"/>
      </div>

      <div v-if="!data.remove_ce_info" class="session-content-block">
        <h3 v-if="data.ce_info?.credit_hours" class="session-content-block__title">
          Earn up to {{ data.ce_info?.credit_hours }} CE Credit Hour{{ data.ce_info?.credit_hours > 1 ? 's' : '' }}
        </h3>
        <h4 class="session-content-block__title" v-if="data.ce_info?.topics?.length">
          <span v-for="(topic, topicIndex) in data.ce_info.topics" :key="`topic-${topicIndex}`">
              <marked-status :icon="topic.icon">{{ topic.title }} <span
                  v-if="topic.hours">({{ topic.hours }})</span></marked-status>&nbsp;
          </span>
        </h4>

        <div
            v-if="data.ce_process_info"
            class="session-content-block__data"
            v-html="data.ce_process_info"
        ></div>

        <hr class="minimal-divider"/>
      </div>

      <div v-if="!data.remove_ce_info && data.target_audience" class="session-content-block">
        <h3 class="session-content-block__title">Target Audience</h3>
        <div class="session-content-block__data" v-html="data.target_audience"></div>

        <hr class="minimal-divider"/>
      </div>

      <div v-if="!data.remove_ce_info && data.approvals?.length" class="session-content-block">
        <h3 class="session-content-block__title">
          Continuing Education Credit Hours are available from the following organizations
        </h3>
        <div class="session-content-block__data">
          <h3
            v-if="inPersonApprovals?.length && virtualApprovals?.length"
            class="session-content-block__title title_underline"
          >In-Person</h3>
          <ul
            v-if="inPersonApprovals?.length"
            class="session-content-block__list no-disc"
          >
            <li
                v-for="(item, index) in inPersonApprovals"
                class="session-content-block__item"
                :class="{'session-content-block__item--no-image': !item.logo_url_base}"
                :key="`approval-${index}`">
              <img v-if="item.logo_url_base" :src="item.logo_url_base" class="item-image" :alt="item.name"/>
              <h4 class="session-content-block__title">{{ item.name }}</h4>
              <div class="session-content-block__data" v-html="item.display_landing_provider_statement"></div>

            </li>
          </ul>

          <h3
            v-if="inPersonApprovals?.length && virtualApprovals?.length"
            class="session-content-block__title title_underline"
          >Virtual</h3>
          <ul
            v-if="virtualApprovals?.length"
            class="session-content-block__list no-disc"
          >
            <li
              v-for="(item, index) in virtualApprovals"
              class="session-content-block__item"
              :class="{'session-content-block__item--no-image': !item.logo_url_base}"
              :key="`approval-${index}`">
              <img v-if="item.logo_url_base" :src="item.logo_url_base" class="item-image" :alt="item.name"/>
              <h4 class="session-content-block__title">{{ item.name }}</h4>
              <div class="session-content-block__data" v-html="item.display_landing_provider_statement"></div>

            </li>
          </ul>
        </div>

        <hr class="minimal-divider"/>
      </div>

      <div v-if="!data.remove_ce_info && data.event_learning_objectives?.length" class="session-content-block">
        <h3 class="session-content-block__title">Event Learning Objectives</h3>
        <div class="session-content-block__data">
          <ul>
            <li
                v-for="(item, index) in data.event_learning_objectives"
                :key="`objective-${index}`">
              {{ item }}
            </li>
          </ul>
        </div>

        <hr class="minimal-divider"/>
        <br />
      </div>

      <div v-if="data.policies?.length" class="session-content-block">
        <h3 class="session-content-block__title">Policies</h3>
        <div class="session-content-block__data">
          <ul class="session-content-block__list no-disc">
            <li
                v-for="(item, index) in data.policies"
                :key="`policy-${index}`"
            >
              <h4 class="session-content-block__title">{{ item.title }}</h4>
              <div class="session-content-block__data" v-html="item.description"></div>
            </li>
          </ul>
        </div>

        <hr class="minimal-divider"/>
      </div>

      <div v-if="!data.remove_ce_info && data.disclosure" class="session-content-block">
        <h3 class="session-content-block__title">Disclosure</h3>
        <div class="session-content-block__data" v-html="data.disclosure"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Container from "../../../components/ui/Container";
import MarkedStatus from "../../../components/ui/MarkedStatus/index";
import AdditionalFixedTabs from "../../../components/ui/AdditionalFixedTabs";
import Notify from "../../../components/ui/Notify";
import ErrorPage from "../../error-page";

export default {
  components: {
    MarkedStatus,
    Container,
    AdditionalFixedTabs,
    Notify,
    ErrorPage,
  },
  mounted() {
    if (!this.hasFetchedData) {
      this.$store.dispatch("ceInfoStore/fetchData", {id: this.attendeeId});
    }
  },
  data() {
    return {
      attendeeId: this.$route.params.attendeeId,
    }
  },
  computed: {
    ...mapGetters('attendeeStore', ['CEInfoTabs', 'isSingleSession']),

    ...mapGetters('ceInfoStore', ['data', 'isFetching', 'hasFetchedData', 'errorStatus']),

    inPersonApprovals() {
      const approvals = Array.isArray(this.data?.approvals) ? this.data.approvals : [];
      return approvals.filter(a => String(a?.visiting_type) === '0');
    },

    virtualApprovals() {
      const approvals = Array.isArray(this.data?.approvals) ? this.data.approvals : [];
      return approvals.filter(a => String(a?.visiting_type) === '1');
    },
  },
}
</script>

<style lang="scss" scoped>
.qr-code-wrapper {
  border: 1px solid var(--attendee-border-color);
  border-radius: var(--attendee-card-border-radius);
  padding: var(--attendee-gap-md);
  grid-gap: var(--attendee-gap-md);
  display: grid;
  justify-content: space-between;
  grid-template-columns: 1fr auto;
  margin-bottom: var(--attendee-gap-md);
  margin-top: var(--attendee-gap-md);
  max-width: 500px;

  h4 {
    font-size: 18px;
  }
}

.ce-info {
  background-color: white;
  border-radius: var(--attendee-card-border-radius);
  padding: var(--attendee-gap-md);

  @media (max-width: 900px) {
    padding-top: 0;
  }

  .additional-fixed-tabs-ce-info{
    padding: 0;
  }

  .no-disc {
    list-style: none;
    display: inline-block;
    width: 100%;

    li {
      list-style: none;
    }
    padding: 0;
  }

  .session-content-block__list {
    li {
      margin-bottom: 40px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .title_underline {
    clear: both;
    text-decoration: underline;
  }

  .item-image {
    float: left;
    width: 100%;
    max-width: 150px;
    margin-right: var(--attendee-gap-md);
    display: block;
    margin-bottom: var(--attendee-gap-md);
  }

  .session-content-block__item {
    clear: both;
  }

  h3 {
    margin-bottom: var(--attendee-gap-xl) !important;
  }

  .minimal-divider {
    border: none;
    height: 1px;
    background-color: var(--attendee-border-color);
    margin: var(--attendee-gap-lg) 0;
  }
}
</style>
